"use strict";

/* Стили */
import "../css/style.scss";
import { initForm } from "./modules/form/init-form";
import initBanner from "./modules/init-banner";
import { initModals } from "./modules/modals/init-modals";
import sliders from "./modules/sliders/sliders";
import { initTabs } from "./modules/tabs/init-tabs";
import trackFormFilling from "./modules/track-form-filling";

/* Скрипты */
import { iosVhFix } from "./utils/ios-vh-fix";

window.addEventListener("DOMContentLoaded", () => {
  iosVhFix();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener("load", () => {
    initTabs();
    sliders();
    initModals();
    initForm();
    trackFormFilling();
    initBanner();
  });
});
